import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { injectIntl } from 'react-intl'

class DotMaps extends Component {
  constructor (props) {
    super(props);
    const { intl } = props;
    this.state = {
      comunities: [
        { name: intl.formatMessage({ id: "ethnicity.belgians" }), img: 'belgian.png', color: 'lightgrey'},
        { name: intl.formatMessage({ id: "ethnicity.eu15" }), img: 'euro15.png', color: '#00B0FF'},
        { name: intl.formatMessage({ id: "ethnicity.northAfricans" }), img: 'NorthAfrican.png', color: '#F50057'},
        { name: intl.formatMessage({ id: "ethnicity.eu13" }), img: 'euroNew13.png', color: '#8BC34A'},
        { name: intl.formatMessage({ id: "ethnicity.subSaharanAfricans" }), img: 'subSaharanAfrica.png', color: '#00E676'},
        { name: intl.formatMessage({ id: "ethnicity.turkish" }), img: 'turkish.png', color: '#FFEA00'},
        { name: intl.formatMessage({ id: "ethnicity.nonEUEuropean" }), img: 'euOther.png', color: '#FF9100'},
        { name: intl.formatMessage({ id: "ethnicity.southAmerican" }), img: 'southAmerican.png', color: '#FF3D00'},
        { name: intl.formatMessage({ id: "ethnicity.other" }), img: 'other.png', color: '#795548'},
      ]
    };
  }

  render() {
    return (
      <Row type="flex">
        <Col span={22} offset={1}>
          <Row type="flex">
            {this.state.comunities.map(c => 
              <Col sm={{ span: 24 }} md={{ span: 8 }} key={c.name}>
                <div style={{ position: 'relative' }}>
                  <h4 style={{ position: 'absolute', left: 20, top: 20, color: c.color }}>{c.name}</h4>
                  <img alt="map" style={{width: "100%"}} src={require(`../../assets/images/dotmaps/${c.img}`)}/>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(DotMaps)